import * as React from 'react';
import {useDispatch} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import {DashboardCard} from 'shells/dashboard/card/dashboard-card';
import {getIllustration} from 'shells/onboarding-checklist/helpers';
import {PromoStateOverlay} from 'shells/promo-state-overlay/promo-state-overlay';

// @ts-expect-error
import {useGetChannelDashboard} from './graphql/hooks';
import * as actions from './report/instagram/instagram-actions';
import {InstagramChart} from './report/instagram/instagram-chart';

import styles from './dashboard.module.css';

const REPORT_PARAMS = {
    dateRangeType: 'period',
    facet: 'count',
    gap: 'd',
    segment: 'interactionType',
} as const;

type Props = {
    dateRange: string;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => void;
    shouldShowPromo: boolean;
};

export function InstagramCard(props: Props) {
    const {activeFilters} = props;

    const {channelDashboard, isLoading} = useGetChannelDashboard({
        timespan: props.dateRange,
        channelType: 'instagram',
    });

    const dispatch = useDispatch();

    const stats = channelDashboard ? channelDashboard.stats : [];

    React.useEffect(() => {
        dispatch(
            actions.requestReportData({
                reportParams: REPORT_PARAMS,
                filters: activeFilters,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFilters]);

    return (
        <DashboardCard
            title='Instagram'
            subtitle='Communicate with customers who message your Instagram account'
            isLoading={isLoading}
            mainContent={{
                statsProps: {stats},
                content: (
                    <div className={styles.chart}>
                        <InstagramChart
                            activeFilters={props.activeFilters}
                            onParamChange={props.onParamChange}
                            reportParams={REPORT_PARAMS}
                            height={346}
                            containerHeight={346}
                        />
                    </div>
                ),
            }}
            promoStateOverlay={
                props.shouldShowPromo && (
                    <PromoStateOverlay
                        promoStateProps={{
                            isHorizontal: true,
                            imageComponent: getIllustration('setupInstagram'),
                            title: 'Integrate Instagram with Nutshell',
                            subtitle:
                                'Connect your Instagram account to Nutshell to start engaging with customers who message your account.',
                            primaryCta: null,
                            secondaryCta: {
                                text: 'Integrate Instagram',
                                url: '/inbox/settings/instagram',
                            },
                            blueImageBackground: true,
                        }}
                    />
                )
            }
        />
    );
}
